<!-- On the dashboard the title and filter rows sit inside the same framed panel
     as the list, matching the table panel it stands beside. -->
<div class="overflow-hidden" [class]="className" [class.table-panel]="isDashboard"
  [class.fill-height]="fillHeight">
  <h2 *ngIf="className === 'dashboard'" class="panel-header page-title m-0 shrink-0">
    {{ "Devices (" + metaData.totalDevicesCount + ")" }}
  </h2>
  <div class="flex justify-between" [ngClass]="{
      'items-end px-10 mb-6 pt-30': !isDashboard,
      'items-center panel-header shrink-0': isDashboard
    }">
    <div class="flex flex-1 flex-col">
      <div class="flex flex-1 flex-row align-bottom">
        <h2 *ngIf="className === 'patient-dialog'" class="text-lg font-bold mb-0">
          Select the preferred device
        </h2>

        <h2 *ngIf="className === 'patients'" class="text-[20px] mb-0 mt-10 font-bold">
          Assign Device
        </h2>
      </div>
      <div class="flex flex-1 justify-between " [ngClass]="{
          'flex-row': !isDashboard,
          'flex-col': isDashboard
        }">
        <!-- The top margin separates the toggle from the heading above it, which
             only the other variants have. -->
        <div class="flex flex-1 flex-row" [class.mt-2]="!isDashboard">
          <!--  Hide this on Live Tests screen  -->
          <mat-button-toggle-group *ngIf="className !== 'patients'" [(value)]="currentFilter"
            [hideSingleSelectionIndicator]="true" name="deviceFilter" aria-label="Device Filter"
            (change)="onFilterChange($event.value)">
            <mat-button-toggle value="all">All ({{ totalDevicesCount }})</mat-button-toggle>
            <mat-button-toggle value="available">Available ({{ availableCount || 0 }})</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div *ngIf="!isDashboard" class="flex flex-1 flex-row justify-end">
          <mat-form-field class="w-[200px]" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput [formControl]="searchControl" />
            <ng-container matSuffix>
              <span class="mr-1 absolute right-[35px]">
                <mat-spinner *ngIf="loader" [diameter]="20"></mat-spinner>
              </span>

              <mat-icon color="primary">search</mat-icon>
            </ng-container>
          </mat-form-field>
        </div>
      </div>
    </div>
    <button *ngIf="isDashboard" class="border-0 flex items-center gap-x-1 cursor-pointer"
      [matMenuTriggerFor]="statusMenu" [disabled]="
        (currentFilter == 'available' && !(availableCount > 0)) ||
        !ability.canEdit(ability.subjects.DeviceStatus)
      ">
      <mat-icon class="scale-75">autorenew</mat-icon>
      <div class="underline">Status</div>
    </button>

    <!-- The menu definition -->
    <mat-menu #statusMenu="matMenu">
      <button mat-menu-item disabled>
        <span class="font-bold">Update all devices status:</span>
      </button>
      <button [disabled]="currentFilter == 'available'" mat-menu-item
        (click)="onAllStatusSelect(deviseStatusEnum.Available)"
        class="group disabled:pointer-events-none disabled:opacity-100 disabled:text-gray-500">
        <div class="flex space-x-2.5 items-center">
          <div class="bg-primary w-2 h-2 rounded-full group-disabled:bg-gray-400"></div>
          <div>Available</div>
        </div>
      </button>
      <button mat-menu-item (click)="onAllStatusSelect(deviseStatusEnum.Charging)">
        <div class="flex space-x-2.5 items-center">
          <div class="bg-blue w-2 h-2 rounded-full"></div>
          <div>Charging</div>
        </div>
      </button>
    </mat-menu>
  </div>
  <!-- The dialog variants leave room below the list for the pagination footer,
       so the footer is not clipped by the panel's own max height. -->
  <div #devicesList class="devices-list flex flex-col overflow-x-hidden overflow-y-auto" [ngClass]="{
      'px-8 pb-2 space-y-2': !isDashboard,
      'max-h-[calc(100vh-340px)]': !isDashboard && !fillHeight,
      'flex-1 min-h-0': fillHeight,
      'dashboard-list': isDashboard
    }" [style.height]="containerHeight">
    <div *ngFor="let device of devices; let isLast = last" (click)="selectDevice(device)"
      [class.isSelected]="device?.id === selectedDevice?.id"
      class="flex w-full items-center justify-between min-h-[140px] cursor-pointer"
      [class.box-divider]="!isLast && isDashboard" [ngClass]="{
        'device-card': !isDashboard,
        'disabled-device':
          !isDashboard && isDeviceOccupied(device.status)
      }">
      <div class="flex flex-col w-full relative">
        <mat-progress-bar *ngIf="device.statusCheckLoading" mode="indeterminate"></mat-progress-bar>
        <div class="flex flex-row justify-between w-full  p-4">
          <!--   LEFT SIDE   -->
          <div class="flex flex-col gap-y-2">
            <div class="flex gap-x-3.5 items-center">
              <div class="text-md font-bold truncate max-w-[276px]">
                {{ device.serial }}
              </div>
              <!-- The lab's own label for the device, where it has one. -->
              <div
                *ngIf="device.customName"
                class="text-sm text-gray-500 truncate max-w-[160px]"
                [matTooltip]="device.customName"
              >
                {{ device.customName }}
              </div>
              <!-- Marks the picked device in the same colour as the card's
                   selected outline, so the two read as one state. -->
              <div *ngIf="device?.id === selectedDevice?.id"
                class="flex items-center justify-center bg-primary w-[19px] h-[19px] rounded-full text-sm text-white font-medium">
                ✓
              </div>
            </div>
            <div class="flex items-top gap-x-1">
              <div class="text-sm">{{ device.deviceType || "No Device Type" }}</div>
              <div class="text-divider-dark">|</div>

              <app-device-size-indicator [size]="device.size"></app-device-size-indicator>
              <span  class="text-divider-dark" *ngIf="device.hasChest || device.hasLeg || device.hasEcg || device.hasAbdomen">
                  |
              </span>
              <div  class="flex flex-wrap gap-x-2 leading-tight w-full" *ngIf="device.hasChest || device.hasLeg || device.hasEcg || device.hasAbdomen">
                <span *ngIf="device.hasChest">+Chest</span>
                <span *ngIf="device.hasLeg">+Leg</span>
                <span *ngIf="device.hasEcg">+ECG</span>
                <span *ngIf="device.hasAbdomen">+Abdomen</span>
                  </div>
            </div>
            <app-status-indicator [online]="device.isOnline" [status]="device.status"></app-status-indicator>
            <app-device-usage-indicator [usageType]="device.usageType"></app-device-usage-indicator>
          </div>
          <!--   RIGHT SIDE   -->
          <div class="flex items-center gap-x-3.5">
            <div class="image relative">
              <img class="h-[68px] w-[60px] mr-[10px]" [src]="'/assets/icons/device.svg'" />

              <div class="flex flex-col absolute gap-y-[3px] right-[-10px]" [ngClass]="
              device.hasChest && device.hasLeg ? 'top-[14px]' : 'bottom-[3px]'
            ">
                <img *ngIf="device.hasChest" [src]="'/assets/icons/chest.svg'" />
                <img *ngIf="device.hasLeg" [src]="'/assets/icons/leg.svg'" />
              </div>
            </div>
          </div>
          <div class="absolute top-3 right-2">
              <span [matTooltip]="
             'Change Status'
          " matTooltipPosition="above" class="inline-block mb-auto">
              <button [disabled]="
              !ability.canEdit(ability.subjects.DeviceStatus)
            " mat-icon-button [matMenuTriggerFor]="menu" aria-label="Device menu">
                <mat-icon [ngClass]="{
                'text-accent opacity-100':

                  ability.canEdit(ability.subjects.DeviceStatus),
                'text-gray-400 opacity-100':
                  !
                  !ability.canEdit(ability.subjects.DeviceStatus)
              }">more_vert</mat-icon>
              </button>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item disabled>
                <span class="font-bold">Update device status:</span>
              </button>
              <button mat-menu-item (click)="
              onSelectedStatusSelect(device, deviseStatusEnum.Available)
            ">
                <div class="flex space-x-2.5 items-center">
                  <div class="bg-primary w-2 h-2 rounded-full"></div>
                  <div>{{ deviceStatusLabel(deviseStatusEnum.Available) }}</div>
                </div>
              </button>
              <button mat-menu-item (click)="
              onSelectedStatusSelect(
                device,
                deviseStatusEnum.AfterUseAwaitingInspection
              )
            ">
                <div class="flex space-x-2.5 items-center">
                  <div class="bg-red w-2 h-2 rounded-full"></div>
                  <div>
                    {{ deviceStatusLabel(deviseStatusEnum.AfterUseAwaitingInspection) }}
                  </div>
                </div>
              </button>

              <button mat-menu-item (click)="
              onSelectedStatusSelect(device, deviseStatusEnum.Charging)
            ">
                <div class="flex space-x-2.5 items-center">
                  <div class="bg-blue w-2 h-2 rounded-full"></div>
                  <div>{{ deviceStatusLabel(deviseStatusEnum.Charging) }}</div>
                </div>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Page through the list with a footer like the table's, in every variant. -->
  <app-pagination class="border-t border-divider shrink-0" [page]="metaData.currentPage"
    [pageSize]="metaData.itemsPerPage" [totalItems]="metaData.totalItems" [disabled]="loader"
    (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
</div>
